<wuc-rack
  columnsMobile="1"
  columnsTablet="2"
  columnsDesktop="3"
  gridGap="medium"
>
    <wuc-card
        padding="large"
        *ngFor="let item of knowledgeBaseItems; let index = index">
        <h3>
            <span class="text text--primary">{{ index + 1 }}.&nbsp;</span>
            <span [innerHTML]="item?.title"></span>
        </h3>
        <p [innerHTML]="item?.summary"></p>
        <wuc-link
            type="secondary"
            [route]="item?.url"
            iconLeft="arrow-right-bold"
            iconSize="xs"
            [title]="item?.title"
        >
            <span [innerHTML]="item?.title"></span>
        </wuc-link>
    </wuc-card>
</wuc-rack>
